/* eslint-disable no-undef */
export const log = (customObj: Record<any, any>) => {
  if (!window.newrelic) return;
  const { errTitle = 'Error', ...errValues } = customObj;
  newrelic.noticeError(errTitle, errValues);
};
